import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  FormControl,
  IconButton,
  Input,
  List,
  ListIcon,
  ListItem,
  useToast,
} from "@chakra-ui/react";
import { ChangeEvent, Dispatch, SetStateAction, useEffect } from "react";
import { GetInput } from "../../../../utils/types/EventType";

interface CustomSelectNoFormProps {
  id: string;
  options: GetInput[] | undefined;
  inputValue: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>; // <- Ajoutez ceci
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleAdd: () => void;
  handleSelect: (option: GetInput) => void;
  handleDelete: (option: GetInput) => void;
}
const CustomSelectNoFormSecondary: React.FC<CustomSelectNoFormProps> = ({
  id,
  options,
  inputValue,
  isOpen,
  setIsOpen, // <- Extrayez setIsOpen de vos props
  handleInputChange,
  handleAdd,
  handleSelect,
  handleDelete,
}) => {
  const toast = useToast();

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      if (isOpen && !event.target.closest(`#${id}`)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [isOpen, setIsOpen, id]);

  return (
    <Box id={id} position="relative" width="300px">
      <FormControl id={id}>
        <Input
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          placeholder={`Sélectionner une zone secondaire`}
          minWidth="300px" // Par exemple, mettez la valeur que vous souhaitez ici
        />
      </FormControl>
      {isOpen && (
        <List
          position="absolute"
          zIndex="dropdown"
          bg="white"
          boxShadow="sm"
          p="2"
          mt="2"
          borderRadius="md"
          width="100%"
        >
          {options?.map((option: GetInput) => (
            <ListItem
              key={option.name}
              py="1"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              transition="box-shadow 0.2s"
              _hover={{ boxShadow: "lg" }}
            >
              <Box
                sx={{ cursor: "pointer" }}
                onClick={(event) => {
                  event.stopPropagation();
                  handleSelect(option);
                }}
              >
                {option.name}
              </Box>
              <IconButton
                aria-label="Supprimer"
                variant="outline"
                size="sm"
                icon={<DeleteIcon color="red" />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(option);
                }}
              />
            </ListItem>
          ))}
          {inputValue &&
            !options?.some((option) => option.name === inputValue) && (
              <ListItem
                mt="2"
                py="1"
                bg="gray.100"
                onClick={(event) => {
                  event.stopPropagation();
                  handleAdd();
                }}
                sx={{ cursor: "pointer" }}
                _hover={{ boxShadow: "lg" }}
              >
                <ListIcon as={AddIcon} boxSize={4} ml="2" />
                Ajouter "{inputValue}"
              </ListItem>
            )}
        </List>
      )}
    </Box>
  );
};

export default CustomSelectNoFormSecondary;
